<style lang="scss">
@import "./styles/contact-stack.scss";
@import "@styles/common.scss";
</style>

<template>
  <div class="contact-stack">
    <ContactSubHeader :title="title" v-if="isCompanyOrganization" />
    <SleekText class="contact-stack-title" xs="sleek-title-3" v-if="!isCompanyOrganization" v-html="title"></SleekText>
    <div class="clearfix"></div>
    <div class="contact-stack-list">
      <div class="contact-stack-list-button" v-if="!isCompanyOrganization">
        <slot name="add-button"></slot>
      </div>
      <draggable class="contact-stack-draggable" :list="list" :options="options" v-if="isCompanyOrganization">
        <ContactCard
          v-for="(contact, index) in list"
          :key="index"
          :contact="contact"
          :is-sleek-director="contact.isNomineeDirector"
          :contacts-topic="contactsTopic"
          :contact-category="contactCategory"
          :is-removable="areCardsRemovable"
          :card-id="index"
        />
      </draggable>
      <draggable class="contact-stack-draggable" :list="list" :options="options" v-if="!isCompanyOrganization">
        <OnboardingContactCard
          v-for="(contact, index) in list"
          :key="index"
          :contact="contact"
          :is-sleek-director="contact.isNomineeDirector"
          :contacts-topic="contactsTopic"
          :contact-category="contactCategory"
          :is-removable="areCardsRemovable"
          :card-id="index"
          :on-boarding-topic="onBoardingTopic"
        />
      </draggable>
    </div>
  </div>
</template>

<script>
// Components
import draggable from "vuedraggable";
import SleekText from "@shared-components/presentational/SleekText.vue";
import ContactCard from "./ContactCard.vue";
import OnboardingContactCard from "./OnboardingContactCard.vue";
import ContactSubHeader from "./ContactSubHeader.vue";

export default {
  name: "ContactStack",
  components: {
    SleekText,
    ContactCard,
    OnboardingContactCard,
    ContactSubHeader,
    draggable
  },
  props: {
    contactCategory: String,
    title: String,
    contacts: Array,
    isBaseStack: Boolean,
    contactsTopic: Object,
    isCompanyOrganization: Boolean,
    areCardsRemovable: {
      type: Boolean,
      default: true
    },
    onBoardingTopic: Object
  },
  data: function() {
    return {
      options: {
        group: {
          name: "contact",
          pull: false,
          put: false
        }
      }
    };
  },
  computed: {
    list: function() {
      return this.contacts;
    }
  }
};
</script>
